import type { Vec2 } from './types';

export function distance(p1: Vec2, p2: Vec2): number {
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

export function circleCircleIntersect(
  c1: { x: number; y: number; radius: number },
  c2: { x: number; y: number; radius: number }
): boolean {
  const dx = c1.x - c2.x;
  const dy = c1.y - c2.y;
  const distSq = dx * dx + dy * dy;
  const rSum = c1.radius + c2.radius;
  return distSq <= rSum * rSum;
}

export function circleBoxIntersect(
  circle: { x: number; y: number; radius: number },
  box: { x: number; y: number; width: number; height: number }
): boolean {
  // box centered at (box.x, box.y)
  const halfW = box.width / 2;
  const halfH = box.height / 2;

  const closestX = Math.max(box.x - halfW, Math.min(circle.x, box.x + halfW));
  const closestY = Math.max(box.y - halfH, Math.min(circle.y, box.y + halfH));

  const dx = circle.x - closestX;
  const dy = circle.y - closestY;

  return dx * dx + dy * dy <= circle.radius * circle.radius;
}

export function pointInBox(
  point: Vec2,
  box: { x: number; y: number; width: number; height: number }
): boolean {
  const halfW = box.width / 2;
  const halfH = box.height / 2;
  return (
    point.x >= box.x - halfW &&
    point.x <= box.x + halfW &&
    point.y >= box.y - halfH &&
    point.y <= box.y + halfH
  );
}

export function clamp(val: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, val));
}
